import React from 'react';
import classnames from 'classnames/bind';
import style from './style.module.less';

const cx = classnames.bind(style);

type Props = {
  tip: string;
};

export const CoverMaskTip: React.FC<Props> = ({ tip }) => (
  <div className={cx('cover-mask')}>
    <div className={cx('hidden-tip')}>{tip}</div>
  </div>
);
